import { render, staticRenderFns } from "./BaseInLineIconButton.vue?vue&type=template&id=8f410b40&scoped=true"
import script from "./BaseInLineIconButton.vue?vue&type=script&lang=js"
export * from "./BaseInLineIconButton.vue?vue&type=script&lang=js"
import style0 from "./BaseInLineIconButton.vue?vue&type=style&index=0&id=8f410b40&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f410b40",
  null
  
)

export default component.exports